export { default } from './CasesList.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/CasesList/index.js